import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {timezones} from "../../../_helpers/timezones";

@Component({
  selector: 'app-select-timezone',
  templateUrl: './select-timezone.component.html',
  styleUrls: ['./select-timezone.component.scss'],
})
export class SelectTimezoneComponent {
  @Input() timezone = '';
  @Output() timezoneChange = new EventEmitter<string>();
  timezones = timezones;
  selectTimezone = (e: SelectCustomEvent) => this.timezoneChange.emit(e.target.value);
}
